import React from 'react';
import LoanPage from './LoanPage';

export const HomeLoan = () => (
  <LoanPage
    title="Home Loan"
    tagline="Own your dream home with tailored home loan solutions from India's leading banks. Get competitive interest rates starting 7%*, tenure up to 30 years, up to 100% property funding and doorstep service across India."
    features={[
      'No upper limit on loan amount',
      'Tenure up to 30 years',
      'Attractive interest rates from 7%*',
      'Up to 100% property funding',
      'Age eligibility up to 70 years',
      'Minimal documentation',
      'Quick approval & disbursal within 7 days',
      'Balance transfer facility for lower EMIs',
      'Special offers for women borrowers',
      'Pradhan Mantri Awas Yojana (PMAY) subsidy support',
    ]}
    eligibility={[
      'Salaried, self-employed & professionals',
      'Age between 21 to 70 years',
      'Minimum monthly income \u20b925,000',
      'Indian resident or NRI',
      'Good credit score (750+ preferred)',
    ]}
    docs={[
      'PAN Card & Aadhaar Card',
      'Latest 3 salary slips / ITR (last 2 years)',
      'Bank statements (last 6 months)',
      'Property documents (Sale deed, NOC, approvals)',
      'Passport size photograph',
      'Address proof',
    ]}
    seo={{
      title: 'Home Loan in India from 7%* | 100% Funding | Age up to 70 | Finirio',
      description: 'Apply for a home loan in India at interest rates starting 7%* with Finirio. No upper limit on amount, up to 100% property funding, age eligibility up to 70 years, tenure up to 30 years.',
      path: '/home-loan',
      keywords: 'home loan, home loan india, home loan 7%, 100% home loan funding, home loan up to 70 years, apply home loan online, housing loan',
      rate: '7% p.a.',
    }}
  />
);

export const LoanAgainstProperty = () => (
  <LoanPage
    title="Loan Against Property"
    tagline="Unlock the value of your property. Get a loan against your residential or commercial property for business expansion, education, medical or personal needs at attractive rates."
    features={[
      'High loan amount up to \u20b910 Crore',
      'Tenure up to 20 years',
      'Competitive interest rates from 9%*',
      'Both residential & commercial property accepted',
      'Overdraft facility available',
      'End-use flexibility',
    ]}
    eligibility={[
      'Age between 25 to 70 years',
      'Property should be self-owned',
      'Minimum monthly income \u20b930,000',
      'Clear property title',
    ]}
    docs={[
      'KYC documents',
      'Income proof (salary slips / ITR)',
      'Property title deed & documents',
      'Bank statements (last 6 months)',
      'Latest property tax receipts',
    ]}
    seo={{
      title: 'Loan Against Property in India | Rates from 9%* | Finirio',
      description: 'Get a loan against your residential or commercial property up to \u20b910 Crore with Finirio. Attractive rates, flexible tenure and quick disbursal.',
      path: '/loan-against-property',
      keywords: 'loan against property, LAP, mortgage loan, property loan india',
      rate: '9% p.a.',
    }}
  />
);

export const BusinessLoan = () => (
  <LoanPage
    title="Business Loan"
    tagline="Grow your business with hassle-free unsecured business loans. Get quick funding for working capital, expansion, machinery or new equipment."
    features={[
      'Loan up to \u20b950 Lakh',
      'Collateral-free',
      'Tenure up to 5 years',
      'Fast disbursal within 72 hours',
      'Flexible repayment options',
      'Minimal documentation',
    ]}
    eligibility={[
      'Business vintage of at least 2 years',
      'Minimum annual turnover \u20b910 Lakh',
      'ITR & audited financials required',
      'Positive credit history',
    ]}
    docs={[
      'PAN, Aadhaar & business proof',
      'ITR (last 2 years) with computation',
      'Bank statements (last 12 months)',
      'GST returns',
      'Business ownership proof',
    ]}
    seo={{
      title: 'Business Loan in India up to \u20b950 Lakh | Collateral-Free | Finirio',
      description: 'Unsecured business loans up to \u20b950 Lakh with Finirio. Quick 72-hour disbursal, flexible tenure and competitive rates from India\u2019s leading banks.',
      path: '/business-loan',
      keywords: 'business loan, msme loan, unsecured business loan, sme loan india',
    }}
  />
);

export const PersonalLoan = () => (
  <LoanPage
    title="Personal Loan"
    tagline="Meet your personal needs \u2014 wedding, travel, medical, education or debt consolidation. Get instant unsecured personal loans with minimal paperwork."
    features={[
      'Loan up to \u20b940 Lakh',
      'Tenure up to 6 years',
      'Instant approval',
      'No collateral required',
      'Attractive interest rates from 10.5%*',
      'End-use flexibility',
    ]}
    eligibility={[
      'Salaried / self-employed',
      'Age between 21 to 60 years',
      'Minimum monthly income \u20b920,000',
      'Good credit score',
    ]}
    docs={[
      'PAN Card & Aadhaar Card',
      'Latest salary slips (3 months)',
      'Bank statements (last 3 months)',
      'Employment proof',
    ]}
    seo={{
      title: 'Personal Loan in India up to \u20b940 Lakh | Instant Approval | Finirio',
      description: 'Instant personal loans up to \u20b940 Lakh at competitive rates with Finirio. Minimal paperwork, quick disbursal and flexible tenure up to 6 years.',
      path: '/personal-loan',
      keywords: 'personal loan, instant personal loan, unsecured personal loan india',
    }}
  />
);

export const WorkingCapital = () => (
  <LoanPage
    title="OD / CC (Working Capital)"
    tagline="Manage your day-to-day business operations with overdraft and cash credit facilities. Withdraw funds as per your business needs and pay interest only on utilised amount."
    features={[
      'Overdraft up to \u20b95 Crore',
      'Interest only on utilised amount',
      'Renewable annually',
      'Available against property or stock',
      'Ideal for MSMEs and traders',
    ]}
    eligibility={[
      'Business vintage 3+ years',
      'Positive net-worth',
      'GST registered entity',
      'Consistent business turnover',
    ]}
    docs={[
      'KYC of business & promoters',
      'ITR & audited financials (last 3 years)',
      'GST returns',
      'Collateral documents',
      'Stock statement (if applicable)',
    ]}
    seo={{
      title: 'Working Capital Loan (OD / CC) up to \u20b95 Crore | Finirio',
      description: 'Overdraft and cash credit working capital facilities up to \u20b95 Crore for MSMEs and businesses. Pay interest only on utilised amount.',
      path: '/working-capital',
      keywords: 'working capital loan, overdraft, cash credit, OD CC, msme loan',
    }}
  />
);
